import { Region } from "components/dataVisualization/restorationZone/RegionFilter";

export const mapRegionFilterToRequestParamValue = (
  regionFilter: Region
): string | null => (regionFilter === Region.AllRegions ? null : regionFilter);
